import { brandData } from '../data/brand-data.js';

export function renderAssessmentView() {
  const { swot, sites } = brandData;

  return `
    <section class="view-section" id="view-assessment">
      <div class="hero-card">
        <span class="hero-tag">Phase 01 Assessment</span>
        <h2>Current Brand Audit & Touchpoint Matrix</h2>
        <p style="max-width: 750px; font-size: var(--text-lg); margin-bottom: 0;">
          An objective evaluation of Urban Village Church's brand equity, touchpoint performance, and visual debt across Chicago sites and digital platforms.
        </p>
      </div>

      <div class="grid-2" style="margin-bottom: var(--space-2xl);">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Brand Strengths (Equity)</h3>
            <span style="color: var(--accent-emerald); font-weight: 700;">+ Internal</span>
          </div>
          <ul style="padding-left: 20px; color: var(--text-secondary); line-height: 1.8;">
            ${swot.strengths.map(s => `<li>${s}</li>`).join('')}
          </ul>
        </div>

        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Brand Weaknesses (Visual Debt)</h3>
            <span style="color: var(--accent-rose); font-weight: 700;">- Internal</span>
          </div>
          <ul style="padding-left: 20px; color: var(--text-secondary); line-height: 1.8;">
            ${swot.weaknesses.map(w => `<li>${w}</li>`).join('')}
          </ul>
        </div>

        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Strategic Opportunities</h3>
            <span style="color: var(--accent-gold); font-weight: 700;">+ External</span>
          </div>
          <ul style="padding-left: 20px; color: var(--text-secondary); line-height: 1.8;">
            ${swot.opportunities.map(o => `<li>${o}</li>`).join('')}
          </ul>
        </div>

        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Environmental Threats</h3>
            <span style="color: var(--text-tertiary); font-weight: 700;">! External</span>
          </div>
          <ul style="padding-left: 20px; color: var(--text-secondary); line-height: 1.8;">
            ${swot.threats.map(t => `<li>${t}</li>`).join('')}
          </ul>
        </div>
      </div>

      <!-- Multi-Site Campus Audit -->
      <div class="card" style="margin-bottom: var(--space-2xl);">
        <div class="card-header">
          <h3 class="card-title">Active Campus Sites Audit</h3>
          <span class="mono" style="font-size: var(--text-xs); color: var(--accent-primary);">4 Physical Sites + Digital Hub</span>
        </div>
        <p style="margin-bottom: var(--space-lg);">
          UVC operates across four distinct Chicago neighborhoods. While relational hospitality is exceptionally strong at each site, signage, print bulletins, and local graphics currently suffer from visual fragmentation.
        </p>
        <div class="grid-2">
          ${sites.map(site => `
            <div style="background: var(--bg-surface-elevated); padding: var(--space-lg); border-radius: var(--radius-md); border: 1px solid var(--border-subtle);">
              <div style="display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 4px;">
                <div style="font-weight: 700; color: var(--text-primary); font-size: var(--text-lg);">${site.name}</div>
                <div class="mono" style="font-size: var(--text-xs); color: var(--accent-gold);">${site.time}</div>
              </div>
              <div style="font-size: var(--text-xs); color: var(--accent-primary); font-weight: 600; margin-bottom: 4px;">${site.venue} • ${site.address}</div>
              <div style="font-size: var(--text-xs); color: var(--text-tertiary); margin-bottom: 8px;">${site.neighborhood}</div>
              <p style="font-size: var(--text-xs); color: var(--text-secondary); margin: 0; line-height: 1.5;">${site.vibe}</p>
            </div>
          `).join('')}
        </div>
      </div>

      <!-- Chicago Landscape Comparison Card -->
      <div class="card">
        <h3 class="card-title" style="margin-bottom: var(--space-md);">Chicago Faith Landscape Benchmarks</h3>
        <p style="margin-bottom: var(--space-md);">
          How Urban Village Church compares against other progressive and mainline faith communities in Chicago:
        </p>
        <div class="grid-3">
          <div style="background: var(--bg-surface-elevated); padding: var(--space-md); border-radius: var(--radius-md);">
            <div style="font-weight: 700; color: var(--text-primary); margin-bottom: 4px;">LaSalle Street Church</div>
            <div style="font-size: var(--text-xs); color: var(--text-tertiary); margin-bottom: 6px;">Near North Side</div>
            <p style="font-size: var(--text-xs); margin: 0;">Historic progressive evangelical roots with strong anti-racist focus. UVC differentiates through multi-site neighborhood accessibility.</p>
          </div>
          <div style="background: var(--bg-surface-elevated); padding: var(--space-md); border-radius: var(--radius-md);">
            <div style="font-weight: 700; color: var(--text-primary); margin-bottom: 4px;">Root & Branch Church</div>
            <div style="font-size: var(--text-xs); color: var(--text-tertiary); margin-bottom: 6px;">Logan Square</div>
            <p style="font-size: var(--text-xs); margin: 0;">Independent 'dinner church' model. UVC differentiates through multi-generational family ministry and scalable neighborhood footprint.</p>
          </div>
          <div style="background: var(--bg-surface-elevated); padding: var(--space-md); border-radius: var(--radius-md);">
            <div style="font-weight: 700; color: var(--text-primary); margin-bottom: 4px;">Fourth Presbyterian</div>
            <div style="font-size: var(--text-xs); color: var(--text-tertiary); margin-bottom: 6px;">Magnificent Mile</div>
            <p style="font-size: var(--text-xs); margin: 0;">Traditional cathedral model with choral excellence. UVC provides an intimate, non-intimidating urban village environment.</p>
          </div>
        </div>
      </div>
    </section>
  `;
}
